<script setup lang="ts">
import '../../class2css/assets/css/style.scss';
import '../../public/tool-fonts/stylesheet.css';
if(import.meta.env.DEV) import('../../class2css/dev/style.css');
import {WebPopup} from "lct-lib";
import {onMounted, ref} from "vue";

const client = ref(false);

onMounted(()=>{
    client.value = true;
})

</script>

<template>
    <div c2c-0 class="">
        <slot></slot>
        <web-popup v-if="client"></web-popup>
    </div>
</template>

<style scoped>

</style><style lang="scss" scoped></style>